import React from 'react'
import "./FlightsTab.css"
import FlightCard from '../FlightCard/FlightCard'

const FlightsTab = () => {

  const flightsData = [
    {
      status: "completed", 
      travelers: "2", 
      price: "578.2",
      flights: [
        {
          departure: "Amsterdam (AMS)",
          destination: "Dubai (DXB)",
          deapartureTime: "Nov 8, 12:00 PM",
          arrivedTime: "Nov 9, 2:10 AM",
          airline: "Pegasus Airlines",
          stops: "1 Stop"
        }
      ]
    },
    {
      status: "canceled", 
      travelers: "2", 
      price: "578.2",
      flights: [
        {
          departure: "Amsterdam (AMS)",
          destination: "Dubai (DXB)",
          deapartureTime: "Nov 8, 12:00 PM",
          arrivedTime: "Nov 9, 2:10 AM",
          airline: "Pegasus Airlines",
          stops: "1 Stop"
        },
        {
          departure: "Dubai (DXB)",
          destination: "Amsterdam (AMS)",
          deapartureTime: "Nov 8, 12:00 PM",
          arrivedTime: "Nov 9, 2:10 AM",
          airline: "Pegasus Airlines",
          stops: "1 Stop"
        }
      ]
    },
    {
      status: "completed", 
      travelers: "2", 
      price: "578.2",
      flights: [
        {
          departure: "Amsterdam (AMS)",
          destination: "Dubai (DXB)",
          deapartureTime: "Nov 8, 12:00 PM",
          arrivedTime: "Nov 9, 2:10 AM",
          airline: "Pegasus Airlines",
          stops: "1 Stop"
        }
      ]
    },
  ]

  return (
    <div className="flight-tab-container">
      {
        flightsData.map((item, index) => (
          <FlightCard 
            key={index}
            flights={item.flights}
            price={item.price}
            status={item.status}
            travelers={item.travelers}
          />
        ))
      }
    </div>
  )
}

export default FlightsTab
